@if (hasItems) {
  @switch (gallery.layout) {
    @case ('MASONRY') {
      <app-gallery-masonry
        [gallery]="gallery"
        [assetBase]="assetBase"
        [videoBase]="videoBase"
        [showGalleryHeading]="showGalleryHeading"
      />
    }
    @case ('FILMSTRIP') {
      <app-gallery-filmstrip
        [gallery]="gallery"
        [assetBase]="assetBase"
        [videoBase]="videoBase"
        [showGalleryHeading]="showGalleryHeading"
      />
    }
    @case ('SHOWCASE') {
      <app-gallery-showcase
        [gallery]="gallery"
        [assetBase]="assetBase"
        [videoBase]="videoBase"
        [showGalleryHeading]="showGalleryHeading"
      />
    }
    @case ('TEXT_BLOCK') {
      <app-gallery-text-block
        [gallery]="gallery"
      />
    }
  }
}
